import React from 'react';

const storyData = [
    {
        id: 1,
        title: "Projects Indus",
        description: "Mobikode at Makers Lab Projects Indus builds smart, user-friendly digital solutions. We focus on clean design, reliable performance, and real-world usability to help businesses grow with modern mobile and web apps. ",
        image: "/assets/lab/img6.png",
    },
    {
        id: 2,
        title: "BHAML ",
        description: "Mobikode at Makers Labs BHAML builds simple, powerful digital products that help startups grow. We focus on real user needs, clean design, and reliable mobile and web development that scales.",
        image: "/assets/lab/img7.png",
    }
];

export default function IndiaStorySection() {
    return (
        <section className="w-full pb-[40px] md:pb-[100px] font-sora bg-white">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-16">

                <div className="md:col-span-5 lg:col-span-6">
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight md:sticky md:top-8">
                        Our India Story
                    </h2>
                </div>

                <div className="md:col-span-7 lg:col-span-6 flex flex-col gap-6">
                    {storyData.map((item) => (
                        <div
                            key={item.id}
                            className="group w-full bg-white border border-[#01386A15] p-5 sm:p-6 md:p-8 flex flex-col gap-4 sm:gap-6 shadow-sm transition-all duration-300 hover:shadow-md relative overflow-hidden rounded-sm"
                        >
                            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
                                <div className="w-[140px] h-[80px] md:w-[180px] md:h-[100px] flex-shrink-0 overflow-hidden rounded-sm bg-[#001c3d]">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-full object-cover transition-transform duration-500 md:group-hover:scale-105 select-none"
                                    />
                                </div>
                                <h3 className="text-[16px] md:text-[20px] font-[600] text-[#01386A]">
                                    {item.title}
                                </h3>
                            </div>

                            <div>
                                <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik leading-relaxed font-medium">
                                    {item.description}
                                </p>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] transition-all duration-500 ease-out group-hover:w-full z-10"></div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
}